"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BillingDateRule = class BillingDateRule extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    onCheckChanged(...args) {
        if (this.isOffsetDaysSet) {
            this.setData('item.offset_days', 0);
        }
        else {
            this.setData('item.offset_days', null);
        }
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    editing;
    onEditing(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("editing");
    }
    labelColsMd;
    onLabel_cols_md(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelColsMd");
    }
    contentColsMd;
    onContent_cols_md(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contentColsMd");
    }
    metadata;
    async $$load_metadata() {
        return this.$app.repo.get('ui_metadata');
    }
    labelAlign;
    isOffsetDaysSet;
    async $$load_isOffsetDaysSet() {
        return this.item.offset_days != null;
    }
    ux;
    dataMembers = ['metadata', 'labelAlign', 'isOffsetDaysSet', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                metadata: null,
                labelAlign: "right",
                isOffsetDaysSet: null,
                ux: null,
            },
        };
    }
    get anchorOptions() {
        if (this.loaded) {
            return this.metadata.billing_date_rule_anchor_options;
        }
        return null;
    }
    get target() {
        if (this.loaded) {
            return this.item;
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_3322283983417540_script_2200_getActionArgs_value($event) {
        this.$nextTick(() => this.onCheckChanged(this.isOffsetDaysSet));
    }
    async act_3322283983417540_script_2200_getActionArgs($event) {
        return {
            value: () => this.act_3322283983417540_script_2200_getActionArgs_value($event),
        };
    }
    async evh_3322283983417540_change(event, scope) {
        return await this.actions.evh_3322283983417540_change.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_2198 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_2197 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_2198,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_2197],
        });
        const act_3322283983417540_script_2200 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3322283983417540_script_2200_getActionArgs,
            events: [],
        });
        const evh_3322283983417540_change_2199 = new core_1.actions.EventHandlerImpl({
            action: act_3322283983417540_script_2200,
            event: "change",
            displayName: "script",
        });
        const evh_3322283983417540_change = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3322283983417540_change_2199],
        });
        return {
            act_7315092382398562_reloadComponentData_2198,
            evh_7315092382398562_reload_2197,
            evh_7315092382398562_reload,
            act_3322283983417540_script_2200,
            evh_3322283983417540_change_2199,
            evh_3322283983417540_change,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], BillingDateRule.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BillingDateRule.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], BillingDateRule.prototype, "editing", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('editing'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BillingDateRule.prototype, "onEditing", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        default: 3,
    }),
    __metadata("design:type", Object)
], BillingDateRule.prototype, "labelColsMd", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelColsMd'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BillingDateRule.prototype, "onLabel_cols_md", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        default: 9,
    }),
    __metadata("design:type", Object)
], BillingDateRule.prototype, "contentColsMd", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contentColsMd'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BillingDateRule.prototype, "onContent_cols_md", null);
BillingDateRule = __decorate([
    (0, vue_property_decorator_1.Component)()
], BillingDateRule);
exports.default = BillingDateRule;
vue_property_decorator_1.Vue.component("BillingDateRule", BillingDateRule);
